import ApiVerified from "@/services/apiVerified";
import ActivityApi from "@/services/activityApi";
import ActivityOfflineApi from "@/services/activityOfflineApi";
import ActivityPredesignedApi from "@/services/activityPredesignedApi";
import AemApi from "@/services/aemApi";
import AdminApi from "@/services/adminApi";
import AffiliationBatchApi from "@/services/affiliationBatchApi";
import AffiliationOpsApi from "@/services/affiliationOpsApi";
import AffiliationReportApi from "@/services/affiliationReportApi";
import AiExecutorApi from "@/services/aiExecutorApi";
import AppSettingsApi from "@/services/appSettingsApi";
import CommonApi from "@/services/commonApi";
import ContentBaseApi from "@/services/contentBaseApi";
import ContentLibraryApi from "@/services/contentLibraryApi";
import ContentReadApi from "@/services/contentReadApi";
import LearnApi from "@/services/learnApi";
import LiveClassApi from "@/services/liveClassApi";
import OlympiadApi from "@/services/olympiadApi";
import PastYearPaperApi from "@/services/pastYearPaperApi";
import PdfReportApi from "@/services/pdfReportApi";
import QrCodeLibraryApi from "@/services/qrCodeLibraryApi";
import QuestionApi from "@/services/questionApi";
import SelfPracticeApi from "@/services/selfPracticeApi";
import SmartBookApi from "@/services/smartBookApi";
import StudentCourseApi from "@/services/studentCourseApi";
import TeacherApi from "@/services/teacherApi";
import TestSeriesApi from "@/services/testSeriesApi";
import TutoringApi from "@/services/tutoringApi";
import UnverifiedUserApi from "@/services/unverifiedUserApi";
import UserApi from "@/services/userApi";
import UserMetricsApi from "@/services/userMetricsApi";
import InteractiveVideoApi from "@/services/interactiveVideoApi";
import { useAppSettingsStore } from "@/stores/core/appSettingsStore";
import { ApiServicesStore } from "@/types/global";
import { defineStore, storeToRefs } from "pinia";

function getInitialApiServicesStore(): ApiServicesStore {
  const appSettingsStore = useAppSettingsStore();
  const { ApiBaseUrl } = storeToRefs(appSettingsStore);
  const initialApiServicesStore: ApiServicesStore = {
    unverifiedUserApi: new UnverifiedUserApi(ApiBaseUrl.value),
    apiVerified: new ApiVerified(ApiBaseUrl.value),
    activityApi: new ActivityApi(ApiBaseUrl.value),
    activityOfflineApi: new ActivityOfflineApi(ApiBaseUrl.value),
    activityPredesignedApi: new ActivityPredesignedApi(ApiBaseUrl.value),
    adminApi: new AdminApi(ApiBaseUrl.value),
    aemApi: new AemApi(ApiBaseUrl.value),
    affiliationOpsApi: new AffiliationOpsApi(ApiBaseUrl.value),
    affiliationBatchApi: new AffiliationBatchApi(ApiBaseUrl.value),
    affiliationReportApi: new AffiliationReportApi(ApiBaseUrl.value),
    aiExecutorApi: new AiExecutorApi(ApiBaseUrl.value),
    appSettingsApi: new AppSettingsApi(ApiBaseUrl.value),
    commonApi: new CommonApi(ApiBaseUrl.value),
    contentBaseApi: new ContentBaseApi(ApiBaseUrl.value),
    contentLibraryApi: new ContentLibraryApi(ApiBaseUrl.value),
    contentReadApi: new ContentReadApi(ApiBaseUrl.value),
    learnApi: new LearnApi(ApiBaseUrl.value),
    liveClassApi: new LiveClassApi(ApiBaseUrl.value),
    olympiadApi: new OlympiadApi(ApiBaseUrl.value),
    pastYearPaperApi: new PastYearPaperApi(ApiBaseUrl.value),
    pdfReportApi: new PdfReportApi(ApiBaseUrl.value),
    qrCodeLibraryApi: new QrCodeLibraryApi(ApiBaseUrl.value),
    questionApi: new QuestionApi(ApiBaseUrl.value),
    selfPracticeApi: new SelfPracticeApi(ApiBaseUrl.value),
    smartBookApi: new SmartBookApi(ApiBaseUrl.value),
    studentCourseApi: new StudentCourseApi(ApiBaseUrl.value),
    teacherApi: new TeacherApi(ApiBaseUrl.value),
    testSeriesApi: new TestSeriesApi(ApiBaseUrl.value),
    tutoringApi: new TutoringApi(ApiBaseUrl.value),
    userApi: new UserApi(ApiBaseUrl.value),
    userMetricsApi: new UserMetricsApi(ApiBaseUrl.value),
    interactiveVideoApi: new InteractiveVideoApi(ApiBaseUrl.value),
  };
  return initialApiServicesStore;
}

export const useApiServicesStore = defineStore("apiServicesStore", {
  state: (): ApiServicesStore => getInitialApiServicesStore(),
});
